//@vendors
const { APIPost } = require('utilities/APIRequestHelper');
const { CAMPAIGN_PRICING_CHANNEL } = require('constants/index');
const { has } = require('lodash');

// @commons
const apiURLBuilder = require('core/apiURLBuilder');

// @constants
const actionTypes = require('constants/actionTypes');

// @utilities
const { getLanguage } = require('core/i18n').i18n

// @actions
const errorActions = require('actions/brokerError');

const collectiveCommissionsInfoRequest = () => ({ type: actionTypes.COLLECTIVE_COMISSION_DATA_REQUEST });

const collectiveCommissionsSuccess = (response) => ({
    type: actionTypes.COLLECTIVE_COMISSION_DATA_SUCCESS,
    payload: {
        titleKey: (response.nodes[0] && response.nodes[0].body[0]) ? response.nodes[0].body[0].summary : "",
        descriptionKey: (response.nodes[0] && response.nodes[0].body[0]) ? response.nodes[0].body[0].value : "",
        url: (response.nodes[0] && response.nodes[0].fieldLink[0]) ? response.nodes[0].fieldLink[0].uri : ""
    }
});

const collectiveCommissionsFailure = error => ({
    type: actionTypes.COLLECTIVE_COMISSION_DATA_FAILURE,
    payload: { error }
});

const getCollectivesCommissionsInfo = (location, history) => (dispatch) => {
    dispatch(collectiveCommissionsInfoRequest());
    const data = {
        query: {
            lang: getLanguage().toUpperCase(),
            location: location,
            type: CAMPAIGN_PRICING_CHANNEL
        }
    }
    APIPost(
        dispatch,
        apiURLBuilder.getURL('campaignWithPricing'),
        data
    ).then(response => {
        const isValidResponse = has(response, "nodes") && has(response.nodes[0], "body");
        if (isValidResponse) {
            dispatch(collectiveCommissionsSuccess(response));
        }
    }).catch(response => {
        if (response.error) {
            dispatch(collectiveCommissionsFailure(response.error));
            dispatch(errorActions.show("brokerAPIErrors-errorPrimaryMessage", true, history));
        } else {
            dispatch(errorActions.show("brokerAPIErrors-errorPrimaryMessage", true, history));
            throw response;
        }
    });
}

module.exports = {
    getCollectivesCommissionsInfo
}


